// extracted by mini-css-extract-plugin
export default {"chip":"Chips_chip__hQK+4","deleteBtn":"Chips_deleteBtn__tgzk8","deleteIcon":"Chips_deleteIcon__heY0c"};